import { FormControl, Grid, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x18800000 {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;
}

export function Command0x18800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    year: 0,
    month: 0,
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
  };

  const [fields, setFields] = React.useState<Form0x18800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x18800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(
        JSON.stringify({
          shutdownTime: { ...fields, [prop]: event.target.value },
        })
      );
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.shutdownTime) {
      params.shutdownTime = {};
    }
    if (!params.shutdownTime.year) {
      params.shutdownTime.year = 0;
    }
    if (!params.shutdownTime.month) {
      params.shutdownTime.month = 0;
    }
    if (!params.shutdownTime.day) {
      params.shutdownTime.day = 0;
    }
    if (!params.shutdownTime.hour) {
      params.shutdownTime.hour = 0;
    }
    if (!params.shutdownTime.minute) {
      params.shutdownTime.minute = 0;
    }
    if (!params.shutdownTime.second) {
      params.shutdownTime.second = 0;
    }

    setFields(params.shutdownTime);
  }, [value]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
            <TextField
              id="year"
              label="Год"
              margin="dense"
              value={fields.year}
              onChange={handleChangeField("year")}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
            <TextField
              id="month"
              label="Месяц"
              margin="dense"
              value={fields.month}
              onChange={handleChangeField("month")}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
            <TextField
              id="day"
              label="День"
              margin="dense"
              value={fields.day}
              onChange={handleChangeField("day")}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
            <TextField
              id="hour"
              label="Час"
              margin="dense"
              value={fields.hour}
              onChange={handleChangeField("hour")}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
            <TextField
              id="minute"
              label="Минута"
              margin="dense"
              value={fields.minute}
              onChange={handleChangeField("minute")}
            />
          </FormControl>
        </Grid>

        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
            <TextField
              id="second"
              label="Секунда"
              margin="dense"
              value={fields.second}
              onChange={handleChangeField("second")}
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}
